/**
 * Created by Shen Mo on 2019/10/22
 */

import { assign, intersection, isArray } from 'lodash-es';

import createStoreFactory from './createStore/createStore';
import createSaga, { END, all, fork } from './saga';

let allStoreDispatcher = [];

// 对于所有的
export const dispatchAll = (...args) => {
	allStoreDispatcher.forEach((d) => d(...args));
};

const _remove = (arr, item) => {
	let idx = arr.indexOf(item);
	if (idx > -1) {
		arr.splice(idx, 1);
	}
};
const _add = (arr, item) => {
	let idx = arr.indexOf(item);
	if (idx === -1) {
		arr.push(item);
	}
};

function createEffects(effectMap) {
	function errorWrapper(saga) {
		return function* () {
			try {
				yield fork(saga);
			} catch (error) {
				console.log(`[model: ${saga.namespace || saga.name}]- mgx-saga has caught an error.`);
				console.log(error);
			}
		};
	}
	return function* rootSaga() {
		yield all(effectMap.map(errorWrapper).map(fork));
	};
}

// store 创建函数
const sagaMiddleware = createSaga();
export const createStore = (defaultState, processor, opt) => {
	const options = assign(
		{},
		{
			LEGAL_CATEGORIES: [],
		},
		opt,
	);

	// 特有的 filter 函数，对于不符合类型的方法进行丢弃处理
	const filter = (store) => (next) => (action) => {
		// console.log('FILTER ACTION', action);
		const category = action.category;
		const LEGAL_CATEGORIES = options.LEGAL_CATEGORIES;
		let _isLegalCategory = true;

		if (LEGAL_CATEGORIES && LEGAL_CATEGORIES.length > 0) {
			if (isArray(category)) {
				_isLegalCategory = intersection(LEGAL_CATEGORIES, category).length > 1;
			} else {
				_isLegalCategory = LEGAL_CATEGORIES.indexOf(category) > -1;
			}
		}
		if (!_isLegalCategory) {
			return;
		}

		return next(action);
	};

	const store = createStoreFactory(processor, defaultState, [filter, sagaMiddleware]);
	_add(allStoreDispatcher, store.dispatch);

	// 传入数组 - 替代一个all的generator函数，对数组中的generator进行包装处理，增加error相关函数
	store.runSaga = (...args) => {
		store._sagaTask = sagaMiddleware.run(createEffects(...args));
	};
	store.close = () => {
		if (store._sagaTask && store._sagaTask.cancel) {
			store._sagaTask.cancel();
		}
		_remove(allStoreDispatcher, store.dispatch);
		store.dispatch(END);
	};
	return store;
};
